export default "__VITE_ASSET__tPNcz6rm__"